import gql from "graphql-tag";

export default {
  mutation: gql`
    mutation addProcessingRole($role: String!, $comment: String) {
      addProcessingRole(role: $role, comment: $comment) {
        success
      }
    }
  `,
  mutationName: "addProcessingRole",
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/users/processingRole/addProcessingRole.js